import { __ } from "@wordpress/i18n";
export const DYNAMIC_OPTIONS_TYPE = [
    { label: __("Normal"), value: "normal" },
    { label: __("Dynamic"), value: "dynamic" },
];
export const OPTIONS_TYPE = [
    { label: __("Normal"), value: "normal" },
    { label: __("Dynamic"), value: "dynamic" },
];
